/* eslint-disable no-unused-vars */
const payments_cols = [
  { field: 'transactionDate', title: 'Transaction Date' },
  { field: 'payment', title: 'Payment' },
  { field: 'paymentType', title: 'Payment Type' },
  { field: 'paymentMethod', title: 'Payment Method' },
  { field: 'previousBalance', title: 'Previous Balance' },
  { field: 'balance', title: 'Balance' },
  { field: 'transactionId', title: 'Transaction Id' },
];

export const downloadCSV = (data, filename) => {
  const csvContent = convertToCSV(data);
  const utf8BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([utf8BOM, csvContent], { type: 'text/csv;charset=UTF-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

function convertToCSV(objArray) {
  if (!objArray) return;
  let array = typeof objArray !== 'object' ? JSON.parse(objArray) : [...objArray];

  let csv = '';

  const columns = payments_cols.map((item) => item.field);
  const formatedHeaders = payments_cols.map((item) => item.title);

  csv += formatedHeaders.join(',') + '\n';

  const formatedArray = array.map((item) => {
    const newItem = {};

    // truncate numbers
    for (const key in item) {
      if (typeof item[key] === 'number') {
        newItem[key] = parseFloat(item[key].toFixed(3)).toString();
      } else {
        newItem[key] = item[key] || '';
      }
    }

    const formatedItem = {};

    // select props and add symbols
    columns.forEach((column) => {
      if (column === 'payment') {
        formatedItem[column] = (newItem[column] > 0 ? '$' : '-$') + Math.abs(newItem[column]);
      } else if (column === 'previousBalance' || column === 'balance') {
        formatedItem[column] = (newItem[column] > 0 ? '$' : '-$') + Math.abs(newItem[column]);
      } else {
        formatedItem[column] = newItem[column];
      }
    });

    return formatedItem;
  });

  // data rows
  for (const row of formatedArray) {
    const values = columns.map((header) => {
      const escaped = String(row[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csv += values.join(',') + '\n';
  }

  return csv;
}
